import ContentPasteOff from '@mui/icons-material/ContentPasteOff';
import { MenuItem } from '@src/common/components/Menu';
import { useToast } from '@src/common/hooks/useToast';
import {
  actionIconStyle,
  menuItemStyle,
} from '@src/orders/components/permitList/PermitActions/PermitActionsStyles';
import { useKeepPermitAsIs } from '@src/orders/hooks/useKeepPermitAsIs';
import { useRefreshOrder } from '@src/orders/hooks/useRefreshOrder';
import { useRefreshOrders } from '@src/orders/hooks/useRefreshOrders';
import type { ComponentPropsWithoutRef } from 'react';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

interface Props extends ComponentPropsWithoutRef<typeof MenuItem> {
  permitId: string;
  orderId: string;
}
export const KeepAsIs = forwardRef<HTMLLIElement, Props>(
  ({ permitId, orderId, ...menuItemProps }, ref) => {
    const { t } = useTranslation();
    const { refreshOrders } = useRefreshOrders();
    const { refreshOrder } = useRefreshOrder({ id: orderId });
    const { showSuccessToast, showErrorToast } = useToast();
    const { keepPermitAsIs } = useKeepPermitAsIs({
      permitApplicationId: permitId,
      onSuccess: () => {
        showSuccessToast(t('permitApplication.keepAsIsWithSuccess'));
        refreshOrder();
        refreshOrders();
      },
      onError: () => showErrorToast(t('permitApplication.keepAsIsWithError')),
    });

    const handleKeepAsIsClick = () => {
      keepPermitAsIs();
    };

    return (
      <>
        <MenuItem
          {...menuItemProps}
          ref={ref}
          className={menuItemStyle}
          onClick={() => handleKeepAsIsClick()}
        >
          <ContentPasteOff style={actionIconStyle} />
          {t('permitApplication.keepAsIs')}
        </MenuItem>
      </>
    );
  },
);
